export function normalizeOrigin(origin) {
  if (!origin) return

  const path = origin.replace(/https?:\/\/[^/]+\/?/, "")

  if (path === "") return "home"
  if (path.startsWith("staff-picks")) return "staff-picks"
  if (path.startsWith("featured-art")) return "exclusives"

  const segments = path.split(/[/?]/)
  const popularStyles = fetchPopularStyles(segments)
  if (popularStyles) {
    return `popular-${popularStyles}-paintings`
  }

  if (path.startsWith("artworks")) return "all-art"

  if (segments[1] === "Artwork") return `listing-${segments[0]}-${segments[2]}`

  return `artist-${segments[0]}`
}

// Example: pop+landscape
function fetchPopularStyles(segments) {
  return (
    ["style", "collection"]
      .map((key) => fetchParamFromPath(key, segments))
      .filter(Boolean)
      .join("-") || null
  )
}

// Example: abstract+pop
function fetchParamFromPath(name, segments) {
  const index = segments.indexOf(name)
  if (index === -1) return

  return segments[index + 1]
}
